<form [formGroup]="form">
  <div class="grid">
    <mat-form-field>
      <mat-label>Tipo de máquina: </mat-label>
      <mat-select [formControl]="tipo_equipamiento_procesamiento_id" required>
        <mat-option *ngFor="let tep of tipoEquipamientoProcesamiento" [value]="tep.id">
          {{tep.nombre}}
        </mat-option>
        <mat-option [value]="0">
          Otro
        </mat-option>
      </mat-select>
      <mat-error *ngIf="tipo_equipamiento_procesamiento_id.invalid">
        Seleccione un tipo de máquina
      </mat-error>
    </mat-form-field>
    <mat-form-field>
      <input matInput placeholder="Marca:" required [formControl]="marca">
      <mat-error *ngIf="marca.invalid">
        Ingrese una marca
      </mat-error>
    </mat-form-field>
    <mat-form-field>
      <input matInput placeholder="Modelo" required [formControl]="modelo">
      <mat-error *ngIf="modelo.invalid">
        Ingrese un modelo
      </mat-error>
    </mat-form-field>
  </div>
</form>